export const columnTitles = ['requestDate', 'status', 'receivedDate', 'amount']
